const type = 'COMPLEMENT_CALL_DETAILS';

const complementCallDetails = (data = []) => ({
  data,
  type,
});

export { type };
export default complementCallDetails;
